import { Injectable } from '@angular/core';

@Injectable()
export class LabelService {
  private _labels: Record<string, string>;

  constructor() {
    this._labels = {};
  }

  /**
   * Sets the list to the variable
   * @param list
   */
  set labels(list: Record<string, string>) {
    this._labels = list;
  }

  /**
   *
   * @returns {_labels}
   * (this.labelService.labels)
   */
  get labels() {
    return this._labels;
  }

  /**
   *
   * @param key
   * @returns {string}: bla
   */
  getLabel(key: string) {
    return this._labels[key];
  }
}
